import { Typography } from '@mui/material';
import { useTranslation } from "react-i18next";
import Grid from '@mui/material/Grid2';

import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SdStorageIcon from '@mui/icons-material/SdStorage';

import CircularProgress, {
    CircularProgressProps,
  } from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

function CircularProgressWithLabel(
    props: CircularProgressProps & { value: number },
  ) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress variant="determinate" {...props} size={40} color="neutral.300"/>
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: 'neutral.300' }}
          >{`${Math.round(props.value)}%`}</Typography>
        </Box>
      </Box>
    );
  }


export default function Usage({ value, max, GoUploadedThisMonth, maxGoUploadPerMonth }) {

    const {  t } = useTranslation();

    return (
        <Grid
            container
            direction="column"
            spacing={2}
        >
            <Tooltip title={`${Math.round(GoUploadedThisMonth * 10) / 10} ${t("Moused")} ${maxGoUploadPerMonth} ${t("Momax")}`} placement="right">
            <Stack
                alignItems="center"
                direction="row"
                spacing={1}
                >
                    <SvgIcon
                        color="neutral.300"
                        fontSize="small"
                    >
                        <CalendarMonthIcon />
                    </SvgIcon>
                    <Typography variant="subtitle2" color="neutral.300">
                    {t("MonthlyUsage")}
                    </Typography>
                    <Box sx={{ flexGrow: 1 }} />
                    <CircularProgressWithLabel value={(parseFloat(GoUploadedThisMonth)/parseFloat(maxGoUploadPerMonth))*100} /> 
                </Stack>  
            </Tooltip>
            <Tooltip title={`${Math.round(value * 10) / 10} ${t("Moused")} ${max} ${t("Momax")}`} placement="right">
            <Stack
                alignItems="center"
                direction="row"
                spacing={1}
                >
                    <SvgIcon
                        color="neutral.300"
                        fontSize="small"
                    >
                        <SdStorageIcon />
                    </SvgIcon>
                    <Typography variant="subtitle2" color="neutral.300">
                    {t("TotalStorage")}
                    </Typography>
                    <Box sx={{ flexGrow: 1 }} />
                    <CircularProgressWithLabel value={(parseFloat(value)/parseFloat(max))*100}  />  
            </Stack>  
            </Tooltip>
        </Grid>
    );
}